'use client';

import BreadCrumbDesktopClient from 'components/bread-crumb/bread-crumb-desktop-client';
import { useTranslations } from 'next-intl';
import styles from '../not-found.module.scss';

export default function BreadCrumbWrapper({ dealerUrl }) {
  const t = useTranslations();
  const breadCrumbItems = [{ label: t('BCT_HOME'), value: dealerUrl }];

  return (
    <div className={styles['not-found__container__bread-crumb']}>
      <BreadCrumbDesktopClient links={breadCrumbItems} isWithoutActiveItem />
    </div>
  );
}
